var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"banner-wrapper",attrs:{"fluid":""}},[_c('v-row',{staticClass:"header py-16 text-center"},[_c('v-col',{attrs:{"lg":"8","offset-lg":"2","sm":"12","offset-sm":"0"}},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h1',[_vm._v(_vm._s(_vm.title))])])],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }